import React from "react";
import { Link } from "components/common";
import Routes from "routing/Routes";
const StreamLink = ({ stream }) => {
  const route = Routes.stream_search(stream.id);
  return /* @__PURE__ */ React.createElement(Link, { to: route }, stream.title);
};
export default StreamLink;
